import * as React from 'react';
import { clsx } from 'clsx';
import { UIText1 } from '@cian/ui-kit';
import {
  IconActionChevronDown16,
  IconActionChevronUp16,
  IconFunctionalShow16,
  IconMapBus16,
} from '@cian/ui-kit-design-tokens/icons';

import { TDistrictMapMode } from '../../../../types/infrastructure';
import * as styles from './styles.css';

type TServiceMode = Exclude<TDistrictMapMode, 'default'>;

const SERVICES: { icon: React.ReactNode; mode: TServiceMode; testId: string; text: string }[] = [
  {
    icon: <IconFunctionalShow16 />,
    mode: 'future',
    testId: 'district-infrastructure-map-service-future',
    text: 'Будущее района',
  },
  {
    icon: <IconMapBus16 />,
    mode: 'ta',
    testId: 'district-infrastructure-map-service-ta',
    text: 'Транспортная доступность',
  },
];

export interface IMapServicesProps {
  hasFuture: boolean;
  hasTransportAccessibility: boolean;
  onSelect(mode: TServiceMode): void;
}

/** Панель «Дополнительно» поверх карты: выбор режима «Будущее района» или «Транспортная доступность». */
export function MapServices({
  hasFuture,
  hasTransportAccessibility,
  onSelect,
}: IMapServicesProps): React.JSX.Element | null {
  const [isOpened, setOpenedState] = React.useState(true);

  const services = SERVICES.filter(({ mode }) => (mode === 'future' ? hasFuture : hasTransportAccessibility));

  if (!services.length) {
    return null;
  }

  return (
    <div className={styles['wrapper']} data-testid="district-infrastructure-map-services">
      <div className={styles['container']}>
        <button className={styles['title-row']} type="button" onClick={() => setOpenedState(current => !current)}>
          <UIText1 fontWeight="bold">Дополнительно</UIText1>
          <span className={styles['chevron']}>
            {isOpened ? <IconActionChevronUp16 /> : <IconActionChevronDown16 />}
          </span>
        </button>
        <div className={clsx(styles['content'], !isOpened && styles['content--collapsed'])}>
          {services.map(({ icon, mode, testId, text }) => (
            <button className={styles['row']} data-testid={testId} key={mode} type="button" onClick={() => onSelect(mode)}>
              {icon}
              <span className={styles['row-text']}>
                <UIText1>{text}</UIText1>
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
